<template>
	<!-- Google Pay lockup, ported verbatim from med-web-funnel/src/components/icons/GooglePayIcon.vue.
	     The four fixed-fill paths are the multicolour "G"; the rest inherits the button's white. -->
	<svg width="60" height="23" viewBox="0 0 60 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M28.2163 11.1871V17.9683H26.0642V1.22272H31.7694C33.2153 1.22272 34.4482 1.70469 35.457 2.66863C36.4882 3.63256 37.0038 4.80946 37.0038 6.19933C37.0038 7.62282 36.4882 8.79972 35.457 9.75245C34.4594 10.7052 33.2265 11.1759 31.7694 11.1759H28.2163V11.1871ZM28.2163 3.2851V9.12476H31.8142C32.6661 9.12476 33.3834 8.83334 33.9438 8.26171C34.5155 7.69007 34.8069 6.99513 34.8069 6.21053C34.8069 5.43714 34.5155 4.75342 33.9438 4.18178C33.3834 3.58773 32.6773 3.2963 31.8142 3.2963H28.2163V3.2851Z"
			class="fill-color"
		/>
		<path
			d="M42.6304 6.13202C44.222 6.13202 45.4774 6.55794 46.3965 7.4098C47.3156 8.26165 47.7751 9.42734 47.7751 10.9069V17.9683H45.7239V16.3767H45.6343C44.7488 17.6881 43.5607 18.3382 42.0812 18.3382C40.8146 18.3382 39.761 17.9683 38.9091 17.2173C38.0573 16.4663 37.6313 15.536 37.6313 14.4152C37.6313 13.227 38.0797 12.2855 38.9764 11.5906C39.8731 10.8845 41.0724 10.537 42.5631 10.537C43.8409 10.537 44.8945 10.7724 45.7127 11.2431V10.75C45.7127 9.99898 45.4213 9.3713 44.8273 8.84449C44.2332 8.31769 43.5383 8.05989 42.7425 8.05989C41.5431 8.05989 40.5904 8.56428 39.8955 9.58426L38.0012 8.39615C39.0436 6.88299 40.5904 6.13202 42.6304 6.13202ZM39.8506 14.4488C39.8506 15.0092 40.086 15.48 40.568 15.8499C41.0388 16.2197 41.5992 16.4103 42.2381 16.4103C43.146 16.4103 43.953 16.074 44.6591 15.4015C45.3653 14.729 45.7239 13.9444 45.7239 13.0365C45.0514 12.5097 44.1211 12.2407 42.9218 12.2407C42.0475 12.2407 41.319 12.4537 40.7361 12.8684C40.1421 13.3055 39.8506 13.8323 39.8506 14.4488Z"
			class="fill-color"
		/>
		<path
			d="M59.4769 6.50189L52.3034 23.0009H50.0841L52.7517 17.2285L48.0217 6.50189H50.3643L53.7717 14.729H53.8166L57.1343 6.50189H59.4769Z"
			class="fill-color"
		/>
		<path
			d="M19.6563 9.81969C19.6563 9.11803 19.5935 8.44664 19.477 7.80103H10.4563V11.4999L15.6515 11.501C15.4408 12.7317 14.7626 13.7808 13.7236 14.4802V16.88H16.816C18.6217 15.2088 19.6563 12.7384 19.6563 9.81969Z"
			fill="#4285F4"
		/>
		<path
			d="M13.7247 14.4803C12.8638 15.0609 11.7553 15.4005 10.4585 15.4005C7.95337 15.4005 5.82822 13.7125 5.06716 11.4371H1.8772V13.912C3.45761 17.0481 6.70585 19.2002 10.4585 19.2002C13.0521 19.2002 15.2311 18.3472 16.8171 16.8789L13.7247 14.4803Z"
			fill="#34A853"
		/>
		<path
			d="M4.76681 9.60119C4.76681 8.9623 4.87329 8.34471 5.0672 7.7641V5.28925H1.87724C1.22378 6.58608 0.85614 8.04992 0.85614 9.60119C0.85614 11.1525 1.2249 12.6163 1.87724 13.9131L5.0672 11.4383C4.87329 10.8577 4.76681 10.2401 4.76681 9.60119Z"
			fill="#FABB05"
		/>
		<path
			d="M10.4585 3.80068C11.8741 3.80068 13.1418 4.28826 14.1427 5.24099L16.8832 2.50273C15.2188 0.952586 13.0488 0.000976562 10.4585 0.000976562C6.70697 0.000976562 3.45761 2.15302 1.8772 5.28918L5.06716 7.76404C5.82822 5.4887 7.95337 3.80068 10.4585 3.80068Z"
			fill="#E94235"
		/>
	</svg>
</template>

<style scoped>
.fill-color {
	fill: var(--text-white-primary, #fff);
}
</style>
